import type { FaireProductEntity } from "../../entity_types/product";

export const p_epvc5ba68j: FaireProductEntity = {
  token: "p_epvc5ba68j",
  type: "product",
  name: "Hand Care Gift Set - Timeless Tin Box",
  brandToken: "b_4l7cxmmbqd",
  brandName: "PANIER DES SENS",
  imageUrl:
    "https://cdn.faire.com/fastly/005bd0a836c7695aca86c14b96d0b0d39d0ead2a65b0b1d8b48cbc47b2b33f10.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9647130c07f30b12a3254dd487cfff02892d7719a4ad129c52414d3efb406c0e.webp",
    "https://cdn.faire.com/fastly/09b5567906b8c9fac033ffa9114acca8cc39f93f30f24ab0d596174cd0ee66d0.webp",
    "https://cdn.faire.com/fastly/7812716d7a48563ce5165556aac4c3799be69097aed6ee2c7aabee088334a917.jpeg",
    "https://cdn.faire.com/fastly/2398a766c745c71f0c0da4afad2934454101b93f03c5466a6c1af99d07d5ef6f.jpeg",
    "https://cdn.faire.com/fastly/2c088fa92846ff3fcd4f71202794f2fa78193e553ad0c0a57019e3d26af71a9a.jpeg",
    "https://cdn.faire.com/fastly/30e928fb6760c9ec0ce4360c9b7ea6f57316dc6eeb992e957e4184135b684229.jpeg",
  ],
  priceDollars: 15,
  description:
    "A gift set with a fresh and tangy design containing a trio of hand creams: Regenerating Honey (30ml), Soothing Almond (30ml), and Energizing Provence (30ml) to nourish, soothe, and protect your hands.\n\n✔️ 97% natural ingredients\n✔️ Delicately perfumes the hands\n✔️ Vegan friendly (except Honey)\n✔️ Made in France\n✔️ Made with shea butter and olive oil\n\n\n\n\n\n\n\nHand cream / Gift set / Mother's day gift / Valentine's gift / Christmas gift / Beauty / Skincare / Self care / Floral / Natural /  Gifts for women / Hand creams / Holiday / Gift set / Stocking stuffers / Holiday gift / stocking stuffers for adults / Gift / Mothers Day Gift Sets\n\n\n",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:17.347Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
